// A meeting's ORIGIN is the record's own `sourceType` — which collection it was
// recorded from (Meeting schema: "lead" | "dailyRequest"). Not the lead's status,
// not the lead's `source` string: a meeting outlives the record it came from, so
// the only honest answer is the one frozen onto the meeting itself.
//
// The server's /api/meetings/export carries an identical two-way mapping for the
// Source column of the workbook; verify-export-completeness.js runs both copies
// over the enum and fails the build if they disagree (owner request 2026-10-01:
// "Source" column on the Meetings page AND in Export Excel).
export function meetingSourceLabel(m) {
  return m && m.sourceType === "dailyRequest" ? "Daily Request" : "Lead";
}
